import { render, staticRenderFns } from "./StatusPeriodButton.vue?vue&type=template&id=3a24f8e4"
import script from "./StatusPeriodButton.vue?vue&type=script&lang=js"
export * from "./StatusPeriodButton.vue?vue&type=script&lang=js"
import style0 from "./StatusPeriodButton.vue?vue&type=style&index=0&id=3a24f8e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports